

$(() => {
    const sameHeight = (element) => {
        const ele = $(element),
            heights = [];
        ele.each((index, element) => {
            const $this = $(element),
                height = $this.css("height", "auto").height();
            heights.push(height);
        });
        const maxHeight = Math.max.apply(null, heights);
        ele.each(() => {
            ele.height(maxHeight);
        });
    };

    const addEqualHeight = () => {
        const winWidth = document.documentElement.clientWidth,
            winHeight = document.documentElement.clientHeight;


        const sectionFeaturedBlocks = $('.team-posts-taxonomy-section .taxonomy-post-grid');
        sectionFeaturedBlocks.each((index, element) => {
            const $this = $(element),
                childElements = $this.find('.div-grid-col');
            if (winWidth > 767) {
                $.each(childElements, (index, element) => {
                    if (index % 4 === 0) {
                        sameHeight(childElements.slice(index, index + 4));
                    }
                });
            } else if (winWidth < 767) {
                $.each(childElements, (index, element) => {
                    if (index % 2 === 0) {
                        sameHeight(childElements.slice(index, index + 2));
                    }
                });
            } else {
                childElements.find('.div-grid-col').removeAttr('style');
            }
        });

    };

    let timer;
    $(window).bind("load resize", function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
            addEqualHeight();
        }, 10);
    });
});
